// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"0655bace","74":"de2a9233","100":"14fbf01c","195":"5dccf889","384":"d6e285f6","609":"1802cc09","777":"e24b67fa","924":"cf9f1a7c"}[chunkId] + ".chunk.js";
};